import type { MouseEvent } from "react";

import { callAll } from "../../../../utils/call-all";
import { primeIcon } from "../../../icon";
import { useFilterPanelContext } from "../../filter-panel.context";
import { ADD_FILTER_LABEL } from "../../messages";
import type { FilterPanelAddButtonProps, FilterPanelAddButtonViewProps } from "./types-add-button";

const PLUS_ICON = primeIcon("plus", 14);

/** ViewModel do FilterPanel.AddButton: desabilita no limite de linhas e soma (`callAll`) o `onClick` da tela ao de adicionar; sem JSX. */
export function useFilterPanelAddButton({
  testId,
  className,
  disabled,
  onClick,
  ...rest
}: FilterPanelAddButtonProps): FilterPanelAddButtonViewProps {
  const { canAddRow, addRow, classNames, partTestId } = useFilterPanelContext();

  return {
    className: [classNames.addButton, className].filter(Boolean).join(" ") || undefined,
    icon: PLUS_ICON,
    label: ADD_FILTER_LABEL,
    disabled: !canAddRow || Boolean(disabled),
    onClick: callAll((_event: MouseEvent<HTMLButtonElement>) => addRow(), onClick),
    testId: testId ?? partTestId("add"),
    rest,
  };
}
